import { render, staticRenderFns } from "./Seminar-Details.vue?vue&type=template&id=5a45efcb&"
import script from "./Seminar-Details.vue?vue&type=script&lang=js&"
export * from "./Seminar-Details.vue?vue&type=script&lang=js&"
import style0 from "./Seminar-Details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports